import clsx from "clsx";
import { Link, useLocation, type LinkProps } from "react-router";

import type { ProcessStep } from "@/types/assignment";

type ProcessStepsProps = {
  assignment_id: string;
  steps: ProcessStep[];
};

export default function ProcessSteps({ assignment_id, steps }: ProcessStepsProps) {
  if (steps.length === 0) return null;
  return (
    <div className="mb-8 inline-flex divide-x divide-solid divide-slate-800 border border-slate-800">
      <NavLink to={`/assignment/${assignment_id}`} className="block px-4 py-1" is_main={true}>
        All candidates
      </NavLink>
      {steps.map((step) => {
        return (
          <NavLink
            key={step.id}
            to={`/assignment/${assignment_id}/process-step/${step.id}`}
            className="block px-4 py-1"
          >
            {step.name} ({step.candidate_ids?.length ?? 0})
          </NavLink>
        );
      })}
    </div>
  );
}

type NavLinkProps = Omit<LinkProps, "to"> & {
  to: string;
  is_main?: boolean;
};

function NavLink({ is_main, to, className, children, ...rest }: NavLinkProps) {
  const location = useLocation();

  const is_active = is_main ? location.pathname === to : location.pathname.startsWith(to);

  return (
    <Link
      {...rest}
      to={to}
      className={clsx(className, is_active && "font-medium text-future-purple")}
    >
      {children}
    </Link>
  );
}
